import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from 'users/queries/shared/keys'
import goldStarsKeys from './shared/keys'
import { GoldStarsAwardParams } from './types'

type Variables = GoldStarsAwardParams

export function useAwardGoldStars(companyId: string | undefined) {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: awardGoldStars,
    onSuccess: async () => {
      client
        .invalidateQueries({ queryKey: goldStarsKeys.all })
        .catch(() => null)
      client.invalidateQueries({ queryKey: keys.detail() }).catch(() => null)
    },
  })

  async function awardGoldStars(params: Variables): Promise<void> {
    if (!companyId) {
      throw new Error('Invalid company id')
    }

    await server.post(`/v2/managers/me/goldstars/${companyId}/award`, {
      to_user_ids: params.toUserIds,
      send_message_to_company_group: params.sendMessageToCompanyGroup,
      send_message_to_store_groups: params.sendMessageToStoreGroups,
      optional_message: params?.optionalMessage,
    })
  }
}
